import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminInquiries.newSupplement;
export const adminNewSupplementMatchingSupplementSelector = (state: RootState) =>
  getState(state).matchingSupplement;
export const adminNewSupplementPendingNewSupplementSelector = (state: RootState) =>
  getState(state).pendingNewSupplement;
